import React from "react";
import cn from "classnames";

import { getDataTestId } from "src/utils";
import { GameProps } from "./types";
import { useContent } from "src/hooks";

import styles from "./style.module.scss";

const TEXTS = ["ДО ГОНКИ", "ГОНКА"];

export const useGame = (props: GameProps) => {
  const content = useContent();

  const isExpected = props.game.status === "expected";
  const isPlay = props.game.status === "play";

  const isDesktop = content === "desktop";
  const isOther = content === "laptop" || content === "mobile" || content === "v3";

  const isVisible = isDesktop || (isOther && (isExpected || isPlay));

  const getGameProps = React.useCallback(
    () => ({
      className: cn(styles[content]),
    }),
    [content]
  );

  const getIdProps = React.useCallback(
    () => ({
      className: cn(styles.id),
      ...getDataTestId("progress-game-id"),
    }),
    []
  );

  const getStatusProps = React.useCallback(
    () => ({
      className: cn(styles.status),
      ...getDataTestId("game-status"),
    }),
    []
  );

  const status = isExpected ? TEXTS[0] : TEXTS[1];

  const values = React.useMemo(
    () => ({
      isVisible,
      status,
    }),
    [isVisible, status]
  );

  return { getGameProps, getIdProps, getStatusProps, values };
};
